import { FC } from 'react';

import { Control, Controller, useFieldArray } from 'react-hook-form';
import {
  FormControl,
  RadioGroup,
  Radio,
  Box,
  HStack,
  VStack,
} from '@chakra-ui/react';

import { RoleForm } from '../models';

export const ActionList: FC<{
  nestIndex: number;
  control: Control<RoleForm, void>;
}> = ({ nestIndex, control }) => {
  const { fields } = useFieldArray({
    control,
    name: `permission.${nestIndex}.permissionActions`,
  });

  return (
    <div>
      {fields.map((item, k) => {
        return (
          <HStack gap="4" align="flex-start" key={item.action.id}>
            <VStack color="custom_blue.1" align="start" flexBasis="25%">
              <Box fontSize="sm" fontWeight="semibold">
                {item.action.description}
              </Box>
            </VStack>
            <FormControl flexBasis="70%">
              <Controller
                control={control}
                name={`permission.${nestIndex}.permissionActions.${k}.enabled`}
                render={({ field }) => (
                  <FormControl>
                    <RadioGroup {...field}>
                      {[
                        { text: 'Yes', value: 'true' },
                        { text: 'No', value: 'false' },
                      ].map(({ text, value }) => (
                        <Radio
                          key={Math.random()}
                          value={value}
                          mr="4"
                          colorScheme="orange"
                        >
                          {text}
                        </Radio>
                      ))}
                    </RadioGroup>
                  </FormControl>
                )}
              />
            </FormControl>
          </HStack>
        );
      })}
    </div>
  );
};
